import "../css/about.css";
import img from "../assets/profile.jpeg";

const AboutMe = () => {
    return (
        <section className="app__about d-flex flex-item-center">
            <div className="app__about-container app__container">
                <div className="app__about-header">
                    <h4> About Me </h4>
                    {/* <h1> Building <span> Engaging Web </span> Experiences with Precision and Passion. </h1> */}
                </div>

                <div className="app__about-body">
                    <div className="app__about-row d-flex flex-item-between gap-4">
                        <div className="app__about-col -left">
                            <div className="app__about-field -active">
                                <p> Hello, I'm <span> Emmanuel Anyigor </span>, a frontend developer specializing in user interface design. With a background in Systems Engineering, I bring a technical and analytical mindset to my work.</p>

                                <p> I hold a Bachelor's degree in Systems Engineering, equipping me with a strong foundation in problem-solving and a systematic approach to development.</p>

                                <p>Currently, I work as a Frontend Developer at <a href="https://blinxhq.com"> Blinx </a>, contributing to the development of cutting-edge web applications.</p>
                            </div>
                            <div className="app__about-field">
                                <h3> Skills </h3>
                                <p>My technical expertise includes <span>HTML</span>, <span>CSS</span>, <span>JavaScript</span>, <span>ReactJS</span>, <span>NodeJS</span>, <span>Python</span>, <span>Firebase</span>, and <span>Java</span>. I utilize these skills to create engaging and responsive user interfaces and collaborate effectively with cross-functional teams.</p>
                            </div>
                            <div className="app__about-field">
                                <h3> Passions & Interest </h3>
                                <p> Beyond my professional pursuits, I have a deep passion for <span>technology</span>, <span>innovation</span>, and <span>continuous learning</span>. I stay updated with the latest trends and tools in frontend development to ensure exceptional results. </p>
                            </div>
                        </div>
                        <div className="app__about-col -right">
                            <div className="app__about-img">
                                <img src={img} alt="Emmanuel Anyigor" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutMe;